import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import pageActions from 'tradera/state/page/actions';
import { getCurrentPageFromRoute } from 'tradera/helpers/get-current-page-helper';

export const TouchwebPageMeta = ({ routeMap }) => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const page = getCurrentPageFromRoute(routeMap, location);
        if (page) {
            const pageMetaData = {
                type: page.pageType
            };
            dispatch(pageActions.setPageMeta(pageMetaData));
        }
    }, [dispatch, location, routeMap]);

    return null;
};
